import type { IconNode } from '../types';

/**
 * @name candlestick
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSIxMSIgeD0iMTAiIHk9IjExIiAvPgogIDxwYXRoIGQ9Ik0xMiA4djMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/candlestick
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candlestick: IconNode = [
  ['rect', { width: '4', height: '11', x: '10', y: '11', key: '1t944q' }],
  ['path', { d: 'M12 8v3', key: 'hwp4zt' }],
];

export default candlestick;
